module.exports = __webpack_public_path__ + "img/2.854f2f1e.jpg";